import styled from 'styled-components';
import {
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    getSpacingToken,
    getTextTokenPreset,
    getToken,
} from '@optimus-web/common';
import { Activable } from '../types';

export const ImageAmountWrapperElement = styled.div<Activable>`
    position: absolute;
    right: ${getSpacingToken('100')}px;
    bottom: ${(props) => (props.active ? getSpacingToken('100') : 0)}px;
    padding: ${getSpacingToken('100')}px;

    display: flex;
    align-items: center;

    border-radius: 4px;
    background-color: ${getToken('backgroundStaticFlat')};
    opacity: ${(props) => (props.active ? 1 : 0)};
    user-select: none;
    ${(props) => props.onClick && `cursor: pointer;`}

    transition: ${ANIMATION_CURVE.default} ${ANIMATION_DURATION.default}ms;
`;

export const ImageAmountTextElement = styled.div`
    ${getTextTokenPreset('bodyLarge')};
    color: ${getToken('textStaticPrimary')};
    margin-left: ${getSpacingToken('100')}px;
`;
